"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getFeatureFlags = getFeatureFlags;
exports.getFeatureFlagsServerSide = getFeatureFlagsServerSide;
exports.resetExperiments = resetExperiments;
exports.setExperiment = setExperiment;
exports.setExperiments = setExperiments;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _experimentActionKeys = _interopRequireDefault(require("./experimentActionKeys"));

var _featureFlagService = _interopRequireDefault(require("./featureFlagService"));

function getFeatureFlags() {
  var url = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '/feature_flags';
  return {
    type: _experimentActionKeys.default.GET_FEATURE_FLAGS,
    payload: _featureFlagService.default.getFeatureFlags(url)
  };
}
/* this exists because in order to allow http call server side a
   http client needs to be initalized with a baseUrl. And in both
   member-app and office-app this isn't done. So you would see a failed promise
   in them. Once they add a baseUrl this can be removed and everyone can
   just use the regular action
*/


function getFeatureFlagsServerSide() {
  var url = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '/feature_flags';
  return {
    type: _experimentActionKeys.default.GET_FEATURE_FLAGS,
    payload: _featureFlagService.default.getFeatureFlagsServerSide(url)
  };
}

function setExperiments(experiments) {
  if (!experiments) {
    throw new Error('Experiments must be defined.');
  }

  return {
    type: _experimentActionKeys.default.SET_EXPERIMENTS,
    payload: experiments
  };
}

function setExperiment(name) {
  var data = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

  if (!name) {
    throw new Error('Experiment name must be defined.');
  }

  return setExperiments((0, _defineProperty2.default)({}, name, data));
}

function resetExperiments() {
  return {
    type: _experimentActionKeys.default.RESET_EXPERIMENTS
  };
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/angieslist-app-platform/lib/common/experiment/experimentActions.js
// module id = 4400
// module chunks = 25